import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/jobs/drawingsReportActions'
import * as api from '../../../api/reports/jobs/drawingsReports'

function* drawingsReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.DRAWINGS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DRAWINGS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* drawingsReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({ type: constants.DRAWINGS_REPORT_GET_ORGANIZATION_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DRAWINGS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* drawingsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.DRAWINGS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DRAWINGS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchdrawingsReportGetJobList() {
  yield takeLatest(constants.DRAWINGS_REPORT_GET_JOB_LIST.ACTION, drawingsReportGetJobList)
}

function* watchdrawingsReportGetOrganizationList() {
  yield takeLatest(
    constants.DRAWINGS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    drawingsReportGetOrganizationList
  )
}

function* watchdrawingsReportGetFullReport() {
  yield takeLatest(constants.DRAWINGS_REPORT_GET_FULL_REPORT.ACTION, drawingsReportGetFullReport)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchdrawingsReportGetOrganizationList),
    fork(watchdrawingsReportGetFullReport),
    fork(watchdrawingsReportGetJobList)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/jobs/drawingsReportSaga.js